/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../../../contexts/KTableProvider'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../../../components/UI'
import {FC, useCallback, useEffect, useMemo, useState} from 'react'
import {KTCard} from '../../../../../../../../../../_metronic/helpers'
import {
  getLaundryGenerateBillingReportPDF,
  getLaundryGenerateBillingReportXLS,
  getLaundryGenerateBillingReportCSV,
  getLaundryGenerateBillingById,
} from '../../../../../../services'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {ButtonWrapper, DrawerReport} from '../../../../../../../../components/UI/Button'
import {LaundryBillingModel} from '../../../../../../features/laundryBilling/model/laundryBilling.model'
import {donwloadFile} from '../../../../../../helpers/utilities'
import {FormattedDate, getFormatDate} from '../../../../../../../../util/functions'

const downloadReportForType = {
  pdf: getLaundryGenerateBillingReportPDF,
  xlsx: getLaundryGenerateBillingReportXLS,
  csv: getLaundryGenerateBillingReportCSV,
}

type TypeDownloadReport = keyof typeof downloadReportForType

const TableLaundryHystory: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const {currentTabItem, isAllowed} = useLavanderia()
  const [isDownload, setIsDownload] = useState<boolean>(false)

  const getLaundryList = useCallback(
    async (props: any = {}) => {
      setLoading(true)
      try {
        const response = await getLaundryGenerateBillingById(
          currentTabItem.idToEdit,
          pagination.currentPage,
        )
        const dataInfo = response.data?.data || []
        setData(dataInfo)
        setPagination({
          ...pagination,
          totalResults: response.data.total,
        })
      } catch (error) {
        console.log(error)
      }
      setLoading(false)
    },
    [setLoading, setData, pagination.currentPage],
  )
  const handleDownloadReport = async (typeFormat: TypeDownloadReport) => {
    try {
      setIsDownload(true)
      const response = await downloadReportForType[typeFormat](currentTabItem.idToEdit)
      await donwloadFile(response.data, typeFormat)
      setIsDownload(false)
    } catch (error) {
      setIsDownload(false)
    }
  }

  const columns: Column<LaundryBillingModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Compañía' />,
        accessor: 'compania',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Cliente' />,
        accessor: 'cliente',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Site' />,
        accessor: 'site',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Punto de Lavandería' />,
        accessor: 'puntoLavado',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Fecha de lavado' />,
        accessor: 'fechaLavado',
        Cell: ({...props}) => {
          let dateCreation = props.data[props.row.index].fechaLavado
            ? getFormatDate(props.data[props.row.index].fechaLavado)
            : ''
          return (
            <span>
              {dateCreation
                ? `${(dateCreation as FormattedDate).fecha} ${
                    (dateCreation as FormattedDate).tiempo
                  }`
                : ''}
            </span>
          )
        },
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Nro orden lavado' />,
        accessor: 'nroOrdenLavado',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo de servicio' />,
        accessor: 'tipoServicio',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Responsable' />,
        accessor: 'responsable',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='DNI' />,
        accessor: 'dni',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Fotocheck' />,
        accessor: 'fotocheck',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Nombres' />,
        accessor: 'nombres',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Apellidos' />,
        accessor: 'apellidos',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Centro de costos' />,
        accessor: 'centroCostos',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Precio por kilo' />,
        accessor: 'precioKilo',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Peso (Kg.)' />,
        accessor: 'pesoKg',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Total (S/.)' />,
        accessor: 'totalPrecio',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Cantidad de prendas' />,
        accessor: 'totalPrendas',
      },
    ],
    [],
  )
  useEffect(() => {
    getLaundryList()
  }, [pagination.currentPage])

  const dataDownloadReport = [
    {
      text: 'Descargar como PDF',
      report: () => handleDownloadReport('pdf'),
    },
    {
      text: 'Descargar como XLSX',
      report: () => handleDownloadReport('xlsx'),
    },
    {
      text: 'Descargar como CSV',
      report: () => handleDownloadReport('csv'),
    },
  ]
  return (
    <>
      <KTCard shadow className='m-5'>
        {isAllowed('HISTORIALPESOS/EXPORTAR') && (
          <div className='p-2'>
            <div className='row'>
              <ButtonWrapper className='sdx-white-bg overflow-visible justify-content-end'>
                <DrawerReport data={dataDownloadReport} loading={isDownload} />
              </ButtonWrapper>
            </div>
          </div>
        )}
        {isAllowed('HISTORIALPESOS/LISTAR') && (
          <>
            <KTable data={data} columns={columns} />
            {loading ? <KTableLoading title='Cargando...' /> : null}
          </>
        )}
      </KTCard>
    </>
  )
}

const TableLaundryHystoryWrapper = () => {
  return (
    <KTableProvider>
      <TableLaundryHystory />
    </KTableProvider>
  )
}
export {TableLaundryHystoryWrapper}
